import React from "react";
import { connect } from "react-redux";
import GeneralDetails from "./GeneralDetails";
import GeneralDetailsSubscriber from "./GeneralDetailsSubscriber";
import GeneralDetailsCancelDeal from "./GeneralDetailsCancelDeal";
import { transactionType } from "../../Page/TransactionSummaryPage/Shared/Constants";
const GeneralDetailsBlock = ({
  data,
  context,
  generalDetails,
  dealType,
  offerName,
  reasonCode,
}) => {
  if (generalDetails.family == "C" && dealType !== transactionType.CancelDeal) {
    return (
      <GeneralDetailsSubscriber
        generalDetails={generalDetails}
        data={data}
        dealType={dealType}
        reasonCode={reasonCode}
      />
    );
  } else if (dealType === transactionType.CancelDeal) {
    return (
      <GeneralDetailsCancelDeal
        generalDetails={generalDetails}
        data={data}
        dealType={dealType}
        reasonCode={reasonCode}
      />
    );
  } else {
    return (
      <GeneralDetails
        generalDetails={generalDetails}
        offerName={offerName}
        data={data}
        dealType={dealType}
        reasonCode={reasonCode}
      />
    );
  }
};

const mapStateToProps = (state) => {
  return {
    generalDetails:
      state.cellcomTransactionSummary.transactionData.generalDetails,
    offerName:
      state.cellcomTransactionSummary.transactionData.programDetails
        ?.programDescriptionDetails[0]?.offerName,
    dealType: state.cellcomTransactionSummary.transactionData.dealType,
    reasonCode: state.cellcomTransactionSummary.transactionData.reasonCode ??
      state.cellcomTransactionSummary.transactionData.generalDetails?.reasonCode,
  };
};

export default connect(mapStateToProps, null)(GeneralDetailsBlock);
